export { TreeDiagram } from './tree.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/components/angular2-tree-diagram/index.js
// module id = ./src/app/components/angular2-tree-diagram/index.js
// module chunks = main